@if (job(); as job) {
  <div class="tw-flex tw-items-start tw-gap-3">
    <!-- Square status glyph: traces while indeterminate, fills with progress,
         and shows a solid tile once the job reaches a terminal state. -->
    <dashboard-ui-loader
      [value]="glyphValue()"
      [label]="job.status | dashboardUiJobStatus"
      [class]="'tw-mt-0.5 tw-text-xl tw-leading-none ' + toneClass()"
    ></dashboard-ui-loader>

    <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-1">
      <div
        class="tw-break-all tw-font-mono tw-text-sm tw-font-semibold tw-leading-tight tw-text-night"
      >
        {{ job.workflowId }}
      </div>

      <div
        class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-0.5 tw-font-firs tw-text-xs tw-text-night-3"
      >
        <span>{{ job.workflowType }}</span>
        <span
          class="tw-text-2xs tw-uppercase tw-tracking-wide"
          [class]="toneClass()"
          >{{ job.status | dashboardUiJobStatus }}</span
        >
      </div>

      @if (job.status === statuses.RUNNING) {
        <div
          class="tw-mt-1 tw-flex tw-items-baseline tw-justify-between tw-gap-3"
        >
          <span
            class="tw-text-sm"
            [class.tw-text-night-2]="!isIndeterminate()"
            [class.tw-text-night-3]="isIndeterminate()"
            >{{ progressMessage() }}</span
          >
          <span
            class="tw-shrink-0 tw-font-mono tw-text-sm tw-tabular-nums"
            [class.tw-text-night]="!isIndeterminate()"
            [class.tw-text-night-4]="isIndeterminate()"
            >{{ overallLabel() }}</span
          >
        </div>

        @if (children().length) {
          <div
            class="tw-mt-2 tw-flex tw-flex-col tw-gap-1.5 tw-border-t tw-border-dashed tw-border-slate-3 tw-pt-2.5"
          >
            @for (child of children(); track $index) {
              <div class="tw-flex tw-items-center tw-gap-2">
                <!-- Same square glyph as the job itself, one size down: traces
                     while the step reports no percentage, fills once it does. -->
                <dashboard-ui-loader
                  [value]="child.value"
                  [label]="child.message"
                  [size]="'sm'"
                  class="tw-shrink-0 tw-text-sm tw-leading-none tw-text-leaf"
                ></dashboard-ui-loader>
                <span class="tw-truncate tw-text-xs tw-text-night-2">{{
                  child.message
                }}</span>
                <span
                  class="tw-ms-auto tw-shrink-0 tw-font-mono tw-text-2xs tw-tabular-nums tw-text-night-3"
                  >{{ child.label }}</span
                >
              </div>
            }
          </div>
        }
      }

      @if (job.error || job.result) {
        <div class="tw-mt-1 tw-font-mono tw-text-xs">
          @if (job.error) {
            <span class="tw-text-raspberry">{{ job.error }}</span>
          }
          @if (job.result && !job.error) {
            <a
              [href]="job.result.url"
              target="_blank"
              class="tw-inline-flex tw-items-center tw-gap-1 tw-text-night-2 tw-underline tw-decoration-slate-2 tw-underline-offset-2 hover:tw-text-night"
            >
              <span>{{ job.result.label || job.result.url }}</span>
              <span
                class="bi bi-arrow-right tw-text-2xs"
                aria-hidden="true"
              ></span>
            </a>
          }
        </div>
      }
    </div>

    <button
      [disabled]="job.status !== statuses.RUNNING"
      class="tw-btn tw-btn-danger tw-shrink-0"
      (click)="cancelJob(job)"
    >
      Cancel
    </button>
  </div>
}
